import { render, staticRenderFns } from "./TransferenciaPosseDefinitiva.vue?vue&type=template&id=9fbc3060&"
import script from "./TransferenciaPosseDefinitiva.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPosseDefinitiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitiva.vue
// module id = 1569
// module chunks = 28